/**
 * Runtime color tokens for Recharts fills and inline styles.
 *
 * MUST mirror tailwind.config.js theme.extend.colors — update both together.
 * Do not import tailwind.config.js here: it pulls Node-only plugin code
 * (flowbite-react/tailwind) into the client bundle.
 *
 * Only mirror values actually consumed at runtime; grow on demand.
 */
export const colors = {
  primary: {
    25: '#F6FBF9',
    50: '#DEE9E5',
    300: '#6DB89A',
    500: '#2B7358',
    600: '#23614A',
    900: '#0D291F',
  },
  // Deep green dark-mode surface ladder (config key "indigo")
  indigo: {
    500: '#1A3D2E',
    600: '#153328',
    900: '#0D291F',
  },
  success: {
    500: '#12B76A',
  },
  error: {
    400: '#F97066',
    500: '#F04438',
  },
  secondary: {
    main: '#E4A036',
    dark: '#B27D2A',
    light: '#FEE7C2',
  },
  text: {
    primaryLight: '#101828',
    primaryDark: '#F2F4F7',
  },
  // Tailwind default grays used at runtime by charts (on-system neutrals)
  gray: {
    100: '#F3F4F6',
    200: '#E5E7EB',
    700: '#374151',
    900: '#111827',
  },
  white: '#FFFFFF',
} as const;
